import { render } from "./data-pesanan.vue?vue&type=template&id=025bd8ce&scoped=true&ts=true"
import script from "./data-pesanan.vue?vue&type=script&lang=ts"
export * from "./data-pesanan.vue?vue&type=script&lang=ts"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./data-pesanan.vue?vue&type=style&index=1&id=025bd8ce&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3714422101/src/github.com/teknologi-kartu/crm-web-admin-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-025bd8ce"]])

export default __exports__